// extracted by mini-css-extract-plugin
export default {"MessagesCarouselWidget":"MessagesCarouselWidget_MessagesCarouselWidget__goBZ7"};